import { Spinner, Typography as T } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import MagnifyingGlassesPeople from 'common/illustrations/MagnifyingGlassesPeople';

import { CenteredRoot, Heading, TextStack } from '../ComplianceContent';

const StyledBody = styled(T.Body1)`
  text-align: center;
  max-width: 400px;
`;

const StyledIllustration = styled(MagnifyingGlassesPeople)`
  height: 213px;
  width: 320px;
`;

const KycProcessing = () => {
  return (
    <CenteredRoot>
      <StyledIllustration />

      <Spinner size="large" />

      <TextStack>
        <Heading>
          <FormattedMessage id="compliance.kyc.processing.heading" />
        </Heading>
        <StyledBody>
          <FormattedMessage id="compliance.kyc.processing.body" />
        </StyledBody>
      </TextStack>
    </CenteredRoot>
  );
};

export default KycProcessing;
